import React from 'react'
import {
  Card,
  CardBody,
  Heading,
  Text,
  VStack,
  Tag,
  Wrap,
  WrapItem,
  Link as ChakraLink,
} from '@chakra-ui/react'
import { ExternalLinkIcon } from '@chakra-ui/icons'
import { Link } from 'react-router-dom'
import { Research, ResearchTag } from '../../types/Research'
import { getTagNames, truncateText } from '../../utils/researchHelpers'

interface ResearchCardProps {
  item: Research
  tags: ResearchTag[]
}

const ResearchCard: React.FC<ResearchCardProps> = ({ item, tags }) => {
  return (
    <Card cursor='pointer' _hover={{ boxShadow: 'md' }}>
      <CardBody>
        <VStack align='start' spacing={3}>
          {/* Title */}
          <Heading
            size='md'
            as={Link}
            to={`/research/${item.id}`}
            color='blue.600'
            _hover={{ textDecoration: 'underline' }}
          >
            {item.title}
          </Heading>

          {/* Journal and Year */}
          <Text fontSize='sm' color='gray.600'>
            {item.journal} • {item.publicationYear}
          </Text>

          {/* Abstract Preview */}
          <Text color='gray.700'>{truncateText(item.abstract)}</Text>

          {/* Tags */}
          {item.tags.length > 0 && (
            <Wrap>
              {getTagNames(item.tags, tags).map((tagName, index) => (
                <WrapItem key={index}>
                  <Tag size='sm' colorScheme='blue' variant='subtle'>
                    {tagName}
                  </Tag>
                </WrapItem>
              ))}
            </Wrap>
          )}

          {/* External Link */}
          <ChakraLink
            href={item.url}
            isExternal
            color='blue.500'
            fontSize='sm'
            display='flex'
            alignItems='center'
          >
            View Full Article <ExternalLinkIcon ml={1} />
          </ChakraLink>
        </VStack>
      </CardBody>
    </Card>
  )
}

export default ResearchCard
